<span
  class="install-action"
  data-testid="install-provider-organization"
  (click)="install()"
>
  <oryx-icon [type]="linkIcon"></oryx-icon>
  {{ label }}
</span>
